import { API_URL } from '../constants';
import { apiRequest } from '../utils/api';

export interface LikeResponse {
  message: string;
  isLiked: boolean;
  likesCount: number;
}

export interface LikeStatusResponse {
  isLiked: boolean;
  likesCount: number;
}

export interface PostLikesResponse {
  likes: Array<{
    id: string;
    postId: string;
    userId: string;
    createdAt: string;
    user: {
      id: string;
      email: string;
      username: string;
      avatar?: string;
    };
  }>;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

class LikeService {
  private baseUrl = API_URL + '/api/likes';

  async toggleLike(postId: string): Promise<LikeResponse> {
    return apiRequest(`${this.baseUrl}/posts/${postId}`, {
      method: 'POST',
    });
  }

  async getPostLikes(postId: string, page: number = 1, limit: number = 10): Promise<PostLikesResponse> {
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    return apiRequest(`${this.baseUrl}/posts/${postId}?${queryParams.toString()}`);
  }

  async checkLikeStatus(postId: string): Promise<LikeStatusResponse> {
    return apiRequest(`${this.baseUrl}/posts/${postId}/status`);
  }
}

const likeService = new LikeService();
export default likeService;
